module.exports = __webpack_public_path__ + "img/cycle-OP3.8d32c84b.jpg";